export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * The `Date` scalar type represents a Date
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Date: { input: any; output: any; }
  /**
   * The `DateTime` scalar type represents a DateTime
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  DateTime: { input: string; output: string; }
  /**
   * Leverages the internal Python implementation of UUID (uuid.UUID) to provide native UUID objects
   * in fields, resolvers and input.
   */
  UUID: { input: string; output: string; }
};

export type AcceptInvitationMutation = {
  __typename?: 'AcceptInvitationMutation';
  organizationSlug: Scalars['String']['output'];
};

export type AcknowledgeNotificationMutation = {
  __typename?: 'AcknowledgeNotificationMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  notification?: Maybe<NotificationType>;
};

export type AcknowledgeNotificationMutationInput = {
  id: Scalars['String']['input'];
};

export type ApiKeyConnectionHeaderType = {
  __typename?: 'ApiKeyConnectionHeaderType';
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ApiKeyType = Node & {
  __typename?: 'ApiKeyType';
  apiKey?: Maybe<Scalars['String']['output']>;
  apiKeyId?: Maybe<Scalars['String']['output']>;
  clients?: Maybe<ClientTypeConnection>;
  id: Scalars['ID']['output'];
};


export type ApiKeyTypeClientsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  domain_Icontains?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_Icontains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ApiKeyTypeConnection = {
  __typename?: 'ApiKeyTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ApiKeyTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ApiKeyType` and its cursor. */
export type ApiKeyTypeEdge = {
  __typename?: 'ApiKeyTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ApiKeyType>;
};

export type ApplicationResourceType = Node & {
  __typename?: 'ApplicationResourceType';
  applications?: Maybe<ClientApplicationTypeConnection>;
  createdAt: Scalars['DateTime']['output'];
  enrichedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isForConsumers: Scalars['Boolean']['output'];
  isSaas: Scalars['Boolean']['output'];
  isVisible: Scalars['Boolean']['output'];
  key?: Maybe<Scalars['String']['output']>;
  mspVitalityScore: Scalars['Int']['output'];
  nonPrimaryResourcesCount?: Maybe<Scalars['Int']['output']>;
  productDescription?: Maybe<Scalars['String']['output']>;
  productDomainName?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  publicResource: ResourceType;
  resourceGroup?: Maybe<TenantedResourceGroupType>;
  updatedAt: Scalars['DateTime']['output'];
  vendorDescription?: Maybe<Scalars['String']['output']>;
  vendorDomainName?: Maybe<Scalars['String']['output']>;
  vendorName?: Maybe<Scalars['String']['output']>;
};


export type ApplicationResourceTypeApplicationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  businessOwner?: InputMaybe<Scalars['ID']['input']>;
  businessOwner_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  clientId_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Date?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Date_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Date_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  employees_Id?: InputMaybe<Scalars['UUID']['input']>;
  employees_Id_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasFileUploads?: InputMaybe<Scalars['Boolean']['input']>;
  hasFileUploadsByEmployee?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  managedBy?: InputMaybe<TenantedClientApplicationManagedByChoices>;
  managedBy_In?: InputMaybe<Array<InputMaybe<TenantedClientApplicationManagedByChoices>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  parentCategoryId?: InputMaybe<Scalars['UUID']['input']>;
  resource_CategoryId?: InputMaybe<Scalars['UUID']['input']>;
  resource_CategoryId_In?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  resource_IsPrimaryResource?: InputMaybe<Scalars['Boolean']['input']>;
  resource_ProductName?: InputMaybe<Scalars['String']['input']>;
  resource_ProductName_Icontains?: InputMaybe<Scalars['String']['input']>;
  resource_ProductName_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  reviewState?: InputMaybe<TenantedClientApplicationReviewStateChoices>;
  reviewState_In?: InputMaybe<Array<InputMaybe<TenantedClientApplicationReviewStateChoices>>>;
  sessionsEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  sessionsStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  supportedBy?: InputMaybe<TenantedClientApplicationSupportedByChoices>;
  supportedBy_In?: InputMaybe<Array<InputMaybe<TenantedClientApplicationSupportedByChoices>>>;
};

export type ApplicationResourceTypeConnection = {
  __typename?: 'ApplicationResourceTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ApplicationResourceTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ApplicationResourceType` and its cursor. */
export type ApplicationResourceTypeEdge = {
  __typename?: 'ApplicationResourceTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ApplicationResourceType>;
};

/** Breakdown of usage for a specific application within the resource group */
export type ApplicationUsageBreakdownType = {
  __typename?: 'ApplicationUsageBreakdownType';
  /** UUID of the application */
  applicationId: Scalars['UUID']['output'];
  /** Name of the application (product name from resource) */
  applicationName?: Maybe<Scalars['String']['output']>;
  /** Number of distinct employees for this application */
  employeeCount: Scalars['Int']['output'];
  /** Event count for this specific application */
  eventCount: Scalars['Int']['output'];
};

export type ApplicationsPerDateType = {
  __typename?: 'ApplicationsPerDateType';
  count?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
};

export type ArchiveNotificationMutation = {
  __typename?: 'ArchiveNotificationMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  notification?: Maybe<NotificationType>;
};

export type ArchiveNotificationMutationInput = {
  id: Scalars['String']['input'];
};

export type AssociateApiKeyWithClientMutation = {
  __typename?: 'AssociateApiKeyWithClientMutation';
  client?: Maybe<ClientType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type AssociateApiKeyWithClientMutationInput = {
  apiKeyId: Scalars['UUID']['input'];
  clientId: Scalars['UUID']['input'];
};

export type AuthenticateImpersonationTokenMutation = {
  __typename?: 'AuthenticateImpersonationTokenMutation';
  impersonationSession?: Maybe<Scalars['Boolean']['output']>;
  organizationSlug: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type AuthenticateOrganizationMutation = {
  __typename?: 'AuthenticateOrganizationMutation';
  organizationSlug: Scalars['String']['output'];
};

export type ClientApiKeyType = Node & {
  __typename?: 'ClientApiKeyType';
  apiKey: ApiKeyType;
  createdAt: Scalars['DateTime']['output'];
  headers?: Maybe<Array<Maybe<ApiKeyConnectionHeaderType>>>;
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ClientApiKeyTypeConnection = {
  __typename?: 'ClientApiKeyTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ClientApiKeyTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ClientApiKeyType` and its cursor. */
export type ClientApiKeyTypeEdge = {
  __typename?: 'ClientApiKeyTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ClientApiKeyType>;
};

export type ClientApplicationActivityType = Node & {
  __typename?: 'ClientApplicationActivityType';
  application?: Maybe<ClientApplicationType>;
  createdAt: Scalars['DateTime']['output'];
  date: Scalars['Date']['output'];
  employee?: Maybe<ClientEmployeeType>;
  eventCount: Scalars['Int']['output'];
  eventType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  resource?: Maybe<ResourceType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ClientApplicationActivityTypeConnection = {
  __typename?: 'ClientApplicationActivityTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ClientApplicationActivityTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ClientApplicationActivityType` and its cursor. */
export type ClientApplicationActivityTypeEdge = {
  __typename?: 'ClientApplicationActivityTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ClientApplicationActivityType>;
};

export type ClientApplicationType = Node & {
  __typename?: 'ClientApplicationType';
  businessOwner?: Maybe<ClientEmployeeType>;
  client: ClientType;
  createdAt: Scalars['DateTime']['output'];
  employees?: Maybe<ClientEmployeeTypeConnection>;
  fileUploads?: Maybe<ClientEmployeeFileUploadTypeConnection>;
  id: Scalars['ID']['output'];
  managedBy?: Maybe<TenantedClientApplicationManagedByChoices>;
  notes?: Maybe<Scalars['String']['output']>;
  notifications?: Maybe<NotificationTypeConnection>;
  resource: ApplicationResourceType;
  /** All applications and stats for the resource group this application belongs to */
  resourceGroupApplications?: Maybe<ResourceGroupApplicationsType>;
  reviewState: TenantedClientApplicationReviewStateChoices;
  sessions?: Maybe<ClientEmployeeSessionTypeConnection>;
  supportedBy?: Maybe<TenantedClientApplicationSupportedByChoices>;
  updatedAt: Scalars['DateTime']['output'];
};


export type ClientApplicationTypeEmployeesArgs = {
  activityDateGte?: InputMaybe<Scalars['Date']['input']>;
  activityDateLte?: InputMaybe<Scalars['Date']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  applicationId?: InputMaybe<Scalars['UUID']['input']>;
  archivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  archivedAt_Gt?: InputMaybe<Scalars['DateTime']['input']>;
  archivedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  archivedAt_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  archivedAt_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  archivedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  archivedById?: InputMaybe<Scalars['ID']['input']>;
  archivedById_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  clientId_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_Icontains?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalId_Icontains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasFileUploads?: InputMaybe<Scalars['Boolean']['input']>;
  hasFileUploadsInApplication?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
};


export type ClientApplicationTypeFileUploadsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  applicationId?: InputMaybe<Scalars['UUID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  datetime?: InputMaybe<Scalars['DateTime']['input']>;
  datetime_Gt?: InputMaybe<Scalars['DateTime']['input']>;
  datetime_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  datetime_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  datetime_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  employeeId?: InputMaybe<Scalars['UUID']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  fileName_Icontains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  mimetype?: InputMaybe<Scalars['String']['input']>;
  mimetype_Icontains?: InputMaybe<Scalars['String']['input']>;
  mimetype_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  sessionId?: InputMaybe<Scalars['UUID']['input']>;
  uploadSize?: InputMaybe<Scalars['Int']['input']>;
  uploadSize_Gt?: InputMaybe<Scalars['Int']['input']>;
  uploadSize_Gte?: InputMaybe<Scalars['Int']['input']>;
  uploadSize_Lt?: InputMaybe<Scalars['Int']['input']>;
  uploadSize_Lte?: InputMaybe<Scalars['Int']['input']>;
};


export type ClientApplicationTypeNotificationsArgs = {
  acknowledgedAt?: InputMaybe<Scalars['DateTime']['input']>;
  acknowledgedAt_Gt?: InputMaybe<Scalars['DateTime']['input']>;
  acknowledgedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  acknowledgedAt_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  acknowledgedAt_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  acknowledgedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  acknowledgedById?: InputMaybe<Scalars['ID']['input']>;
  acknowledgedById_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  applicationId?: InputMaybe<Scalars['UUID']['input']>;
  applicationId_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  applicationProductName?: InputMaybe<Scalars['String']['input']>;
  application_Resource_ProductName?: InputMaybe<Scalars['String']['input']>;
  application_Resource_ProductName_Icontains?: InputMaybe<Scalars['String']['input']>;
  application_Resource_ProductName_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  archivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  archivedAt_Gt?: InputMaybe<Scalars['DateTime']['input']>;
  archivedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  archivedAt_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  archivedAt_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  archivedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  archivedById?: InputMaybe<Scalars['ID']['input']>;
  archivedById_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  clientId_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  employeeId?: InputMaybe<Scalars['UUID']['input']>;
  employeeId_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  executedAt?: InputMaybe<Scalars['DateTime']['input']>;
  executedAt_Gt?: InputMaybe<Scalars['DateTime']['input']>;
  executedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  executedAt_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  executedAt_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  executedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ignoredUntil?: InputMaybe<Scalars['DateTime']['input']>;
  ignoredUntil_Gt?: InputMaybe<Scalars['DateTime']['input']>;
  ignoredUntil_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  ignoredUntil_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  ignoredUntil_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  ignoredUntil_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  notificationType?: InputMaybe<NotificationEnum>;
  notificationType_In?: InputMaybe<Array<InputMaybe<NotificationEnum>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  resolvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  resolvedAt_Gt?: InputMaybe<Scalars['DateTime']['input']>;
  resolvedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  resolvedAt_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  resolvedAt_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  resolvedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  resolvedById?: InputMaybe<Scalars['ID']['input']>;
  resolvedById_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type ClientApplicationTypeSessionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  applicationId?: InputMaybe<Scalars['UUID']['input']>;
  applicationId_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  clientId_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  createdAt_Gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  domain_Icontains?: InputMaybe<Scalars['String']['input']>;
  employeeId?: InputMaybe<Scalars['UUID']['input']>;
  employeeId_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isAuthenticated?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  parentCategoryId?: InputMaybe<Scalars['UUID']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  updatedAt_Gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ClientApplicationTypeConnection = {
  __typename?: 'ClientApplicationTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ClientApplicationTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ClientApplicationType` and its cursor. */
export type ClientApplicationTypeEdge = {
  __typename?: 'ClientApplicationTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ClientApplicationType>;
};

export type ClientApplicationUsageType = {
  __typename?: 'ClientApplicationUsageType';
  applicationId?: Maybe<Scalars['UUID']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  totalSignIns?: Maybe<Scalars['Int']['output']>;
  uniqueSignIns?: Maybe<Scalars['Int']['output']>;
};

/**
 * Represents an application (or group of applications) that a client employee has interacted with.
 * Groups applications by resource group, showing the primary application as the main representation.
 */
export type ClientEmployeeApplicationInteractionType = {
  __typename?: 'ClientEmployeeApplicationInteractionType';
  application: ClientApplicationType;
  firstInteractionAt: Scalars['DateTime']['output'];
  lastInteractionAt: Scalars['DateTime']['output'];
  primaryResource: ApplicationResourceType;
  /** Other applications in the same resource group that the employee has interacted with */
  relatedApplications?: Maybe<Array<ClientApplicationType>>;
  resourceGroup: TenantedResourceGroupType;
  totalInteractions: Scalars['Int']['output'];
};

/** Complete result set for client employee application interactions query */
export type ClientEmployeeApplicationInteractionsResultType = {
  __typename?: 'ClientEmployeeApplicationInteractionsResultType';
  /** Daily summary of application usage */
  dailySummary: Array<ClientEmployeeInteractionSummaryType>;
  /** Number of resource groups after applying filters */
  filteredCount: Scalars['Int']['output'];
  /** List of application interactions grouped by resource group */
  interactions: Array<ClientEmployeeApplicationInteractionType>;
  /** Total number of unique resource groups interacted with (unfiltered) */
  totalCount: Scalars['Int']['output'];
};

export type ClientEmployeeFileUploadType = Node & {
  __typename?: 'ClientEmployeeFileUploadType';
  application?: Maybe<ClientApplicationType>;
  createdAt: Scalars['DateTime']['output'];
  datetime: Scalars['DateTime']['output'];
  employee?: Maybe<ClientEmployeeType>;
  fileName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mimetype: Scalars['String']['output'];
  session?: Maybe<ClientEmployeeSessionType>;
  updatedAt: Scalars['DateTime']['output'];
  uploadSize: Scalars['Int']['output'];
};

export type ClientEmployeeFileUploadTypeConnection = {
  __typename?: 'ClientEmployeeFileUploadTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ClientEmployeeFileUploadTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ClientEmployeeFileUploadType` and its cursor. */
export type ClientEmployeeFileUploadTypeEdge = {
  __typename?: 'ClientEmployeeFileUploadTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ClientEmployeeFileUploadType>;
};

export type ClientEmployeeHistoricalActivityConnection = {
  __typename?: 'ClientEmployeeHistoricalActivityConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ClientEmployeeHistoricalActivityEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ClientEmployeeHistoricalActivity` and its cursor. */
export type ClientEmployeeHistoricalActivityEdge = {
  __typename?: 'ClientEmployeeHistoricalActivityEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ClientEmployeeHistoricalActivityType>;
};

export type ClientEmployeeHistoricalActivityType = Node & {
  __typename?: 'ClientEmployeeHistoricalActivityType';
  application?: Maybe<ClientApplicationType>;
  description: Scalars['String']['output'];
  eventType: HistoricalActivityEventTypeEnum;
  id: Scalars['ID']['output'];
  notification?: Maybe<NotificationType>;
  timestamp: Scalars['DateTime']['output'];
};

/** Daily summary of employee's application interactions */
export type ClientEmployeeInteractionSummaryType = {
  __typename?: 'ClientEmployeeInteractionSummaryType';
  date: Scalars['Date']['output'];
  /** Total number of unique applications used on this date */
  uniqueApplications: Scalars['Int']['output'];
  /** Number of unique resource groups (primary applications) used on this date */
  uniqueResourceGroups: Scalars['Int']['output'];
};

export type ClientEmployeeSessionAggregateDistinctFieldType = {
  __typename?: 'ClientEmployeeSessionAggregateDistinctFieldType';
  applicationId?: Maybe<Scalars['Int']['output']>;
  employeeId?: Maybe<Scalars['Int']['output']>;
};

export type ClientEmployeeSessionAggregateGroupByFieldType = {
  __typename?: 'ClientEmployeeSessionAggregateGroupByFieldType';
  applicationsPerDate?: Maybe<Array<Maybe<ApplicationsPerDateType>>>;
  sessionsPerDate?: Maybe<Array<Maybe<SessionsPerDateType>>>;
};

export type ClientEmployeeSessionAggregateMaxFieldType = {
  __typename?: 'ClientEmployeeSessionAggregateMaxFieldType';
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ClientEmployeeSessionAggregateType = {
  __typename?: 'ClientEmployeeSessionAggregateType';
  distinct?: Maybe<ClientEmployeeSessionAggregateDistinctFieldType>;
  groupBy?: Maybe<ClientEmployeeSessionAggregateGroupByFieldType>;
  max?: Maybe<ClientEmployeeSessionAggregateMaxFieldType>;
};

export type ClientEmployeeSessionType = Node & {
  __typename?: 'ClientEmployeeSessionType';
  application?: Maybe<ClientApplicationType>;
  client: ClientType;
  createdAt: Scalars['DateTime']['output'];
  domain?: Maybe<Scalars['String']['output']>;
  employee: ResourceGroupEmployeeType;
  fileUploads?: Maybe<ClientEmployeeFileUploadTypeConnection>;
  id: Scalars['ID']['output'];
  isAuthenticated?: Maybe<Scalars['Boolean']['output']>;
  loginMethod: TenantedClientEmployeeSessionLoginMethodChoices;
  sessionId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


export type ClientEmployeeSessionTypeFileUploadsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  applicationId?: InputMaybe<Scalars['UUID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  datetime?: InputMaybe<Scalars['DateTime']['input']>;
  datetime_Gt?: InputMaybe<Scalars['DateTime']['input']>;
  datetime_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  datetime_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  datetime_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  employeeId?: InputMaybe<Scalars['UUID']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  fileName_Icontains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  mimetype?: InputMaybe<Scalars['String']['input']>;
  mimetype_Icontains?: InputMaybe<Scalars['String']['input']>;
  mimetype_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  sessionId?: InputMaybe<Scalars['UUID']['input']>;
  uploadSize?: InputMaybe<Scalars['Int']['input']>;
  uploadSize_Gt?: InputMaybe<Scalars['Int']['input']>;
  uploadSize_Gte?: InputMaybe<Scalars['Int']['input']>;
  uploadSize_Lt?: InputMaybe<Scalars['Int']['input']>;
  uploadSize_Lte?: InputMaybe<Scalars['Int']['input']>;
};

export type ClientEmployeeSessionTypeConnection = {
  __typename?: 'ClientEmployeeSessionTypeConnection';
  aggregate?: Maybe<ClientEmployeeSessionAggregateType>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ClientEmployeeSessionTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ClientEmployeeSessionType` and its cursor. */
export type ClientEmployeeSessionTypeEdge = {
  __typename?: 'ClientEmployeeSessionTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ClientEmployeeSessionType>;
};

export type ClientEmployeeType = Node & {
  __typename?: 'ClientEmployeeType';
  applications?: Maybe<ClientApplicationTypeConnection>;
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  archivedBy?: Maybe<UserType>;
  client: ClientType;
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  fileUploads?: Maybe<ClientEmployeeFileUploadTypeConnection>;
  /** Chronological historical activity for the employee across applications and notifications. */
  historicalActivities?: Maybe<ClientEmployeeHistoricalActivityConnection>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** Number of unique resource groups where the employee is assigned to applications */
  resourceGroupCount: Scalars['Int']['output'];
  sessions?: Maybe<ClientEmployeeSessionTypeConnection>;
  updatedAt: Scalars['DateTime']['output'];
};


export type ClientEmployeeTypeApplicationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  businessOwner?: InputMaybe<Scalars['ID']['input']>;
  businessOwner_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  clientId_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Date?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Date_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Date_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  employees_Id?: InputMaybe<Scalars['UUID']['input']>;
  employees_Id_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasFileUploads?: InputMaybe<Scalars['Boolean']['input']>;
  hasFileUploadsByEmployee?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  managedBy?: InputMaybe<TenantedClientApplicationManagedByChoices>;
  managedBy_In?: InputMaybe<Array<InputMaybe<TenantedClientApplicationManagedByChoices>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  parentCategoryId?: InputMaybe<Scalars['UUID']['input']>;
  resource_CategoryId?: InputMaybe<Scalars['UUID']['input']>;
  resource_CategoryId_In?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  resource_IsPrimaryResource?: InputMaybe<Scalars['Boolean']['input']>;
  resource_ProductName?: InputMaybe<Scalars['String']['input']>;
  resource_ProductName_Icontains?: InputMaybe<Scalars['String']['input']>;
  resource_ProductName_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  reviewState?: InputMaybe<TenantedClientApplicationReviewStateChoices>;
  reviewState_In?: InputMaybe<Array<InputMaybe<TenantedClientApplicationReviewStateChoices>>>;
  sessionsEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  sessionsStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  supportedBy?: InputMaybe<TenantedClientApplicationSupportedByChoices>;
  supportedBy_In?: InputMaybe<Array<InputMaybe<TenantedClientApplicationSupportedByChoices>>>;
};


export type ClientEmployeeTypeFileUploadsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  applicationId?: InputMaybe<Scalars['UUID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  datetime?: InputMaybe<Scalars['DateTime']['input']>;
  datetime_Gt?: InputMaybe<Scalars['DateTime']['input']>;
  datetime_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  datetime_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  datetime_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  employeeId?: InputMaybe<Scalars['UUID']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  fileName_Icontains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  mimetype?: InputMaybe<Scalars['String']['input']>;
  mimetype_Icontains?: InputMaybe<Scalars['String']['input']>;
  mimetype_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  sessionId?: InputMaybe<Scalars['UUID']['input']>;
  uploadSize?: InputMaybe<Scalars['Int']['input']>;
  uploadSize_Gt?: InputMaybe<Scalars['Int']['input']>;
  uploadSize_Gte?: InputMaybe<Scalars['Int']['input']>;
  uploadSize_Lt?: InputMaybe<Scalars['Int']['input']>;
  uploadSize_Lte?: InputMaybe<Scalars['Int']['input']>;
};


export type ClientEmployeeTypeHistoricalActivitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type ClientEmployeeTypeSessionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  applicationId?: InputMaybe<Scalars['UUID']['input']>;
  applicationId_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  clientId_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  createdAt_Gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  domain_Icontains?: InputMaybe<Scalars['String']['input']>;
  employeeId?: InputMaybe<Scalars['UUID']['input']>;
  employeeId_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isAuthenticated?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  parentCategoryId?: InputMaybe<Scalars['UUID']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  updatedAt_Gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ClientEmployeeTypeConnection = {
  __typename?: 'ClientEmployeeTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ClientEmployeeTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ClientEmployeeType` and its cursor. */
export type ClientEmployeeTypeEdge = {
  __typename?: 'ClientEmployeeTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ClientEmployeeType>;
};

export type ClientType = Node & {
  __typename?: 'ClientType';
  apiKeyConnections?: Maybe<ClientApiKeyTypeConnection>;
  applications?: Maybe<ClientApplicationTypeConnection>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  domain: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  employees?: Maybe<ClientEmployeeTypeConnection>;
  extensionAdoptionRate?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  notifications?: Maybe<NotificationTypeConnection>;
  trackingSessions?: Maybe<ClientEmployeeSessionTypeConnection>;
  updatedAt: Scalars['DateTime']['output'];
};


export type ClientTypeApiKeyConnectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ClientTypeApplicationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  businessOwner?: InputMaybe<Scalars['ID']['input']>;
  businessOwner_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  clientId_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Date?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Date_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Date_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  employees_Id?: InputMaybe<Scalars['UUID']['input']>;
  employees_Id_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasFileUploads?: InputMaybe<Scalars['Boolean']['input']>;
  hasFileUploadsByEmployee?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  managedBy?: InputMaybe<TenantedClientApplicationManagedByChoices>;
  managedBy_In?: InputMaybe<Array<InputMaybe<TenantedClientApplicationManagedByChoices>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  parentCategoryId?: InputMaybe<Scalars['UUID']['input']>;
  resource_CategoryId?: InputMaybe<Scalars['UUID']['input']>;
  resource_CategoryId_In?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  resource_IsPrimaryResource?: InputMaybe<Scalars['Boolean']['input']>;
  resource_ProductName?: InputMaybe<Scalars['String']['input']>;
  resource_ProductName_Icontains?: InputMaybe<Scalars['String']['input']>;
  resource_ProductName_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  reviewState?: InputMaybe<TenantedClientApplicationReviewStateChoices>;
  reviewState_In?: InputMaybe<Array<InputMaybe<TenantedClientApplicationReviewStateChoices>>>;
  sessionsEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  sessionsStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  supportedBy?: InputMaybe<TenantedClientApplicationSupportedByChoices>;
  supportedBy_In?: InputMaybe<Array<InputMaybe<TenantedClientApplicationSupportedByChoices>>>;
};


export type ClientTypeEmployeesArgs = {
  activityDateGte?: InputMaybe<Scalars['Date']['input']>;
  activityDateLte?: InputMaybe<Scalars['Date']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  applicationId?: InputMaybe<Scalars['UUID']['input']>;
  archivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  archivedAt_Gt?: InputMaybe<Scalars['DateTime']['input']>;
  archivedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  archivedAt_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  archivedAt_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  archivedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  archivedById?: InputMaybe<Scalars['ID']['input']>;
  archivedById_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  clientId_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_Icontains?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalId_Icontains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasFileUploads?: InputMaybe<Scalars['Boolean']['input']>;
  hasFileUploadsInApplication?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
};


export type ClientTypeNotificationsArgs = {
  acknowledgedAt?: InputMaybe<Scalars['DateTime']['input']>;
  acknowledgedAt_Gt?: InputMaybe<Scalars['DateTime']['input']>;
  acknowledgedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  acknowledgedAt_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  acknowledgedAt_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  acknowledgedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  acknowledgedById?: InputMaybe<Scalars['ID']['input']>;
  acknowledgedById_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  applicationId?: InputMaybe<Scalars['UUID']['input']>;
  applicationId_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  applicationProductName?: InputMaybe<Scalars['String']['input']>;
  application_Resource_ProductName?: InputMaybe<Scalars['String']['input']>;
  application_Resource_ProductName_Icontains?: InputMaybe<Scalars['String']['input']>;
  application_Resource_ProductName_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  archivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  archivedAt_Gt?: InputMaybe<Scalars['DateTime']['input']>;
  archivedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  archivedAt_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  archivedAt_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  archivedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  archivedById?: InputMaybe<Scalars['ID']['input']>;
  archivedById_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  clientId_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  employeeId?: InputMaybe<Scalars['UUID']['input']>;
  employeeId_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  executedAt?: InputMaybe<Scalars['DateTime']['input']>;
  executedAt_Gt?: InputMaybe<Scalars['DateTime']['input']>;
  executedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  executedAt_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  executedAt_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  executedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ignoredUntil?: InputMaybe<Scalars['DateTime']['input']>;
  ignoredUntil_Gt?: InputMaybe<Scalars['DateTime']['input']>;
  ignoredUntil_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  ignoredUntil_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  ignoredUntil_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  ignoredUntil_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  notificationType?: InputMaybe<NotificationEnum>;
  notificationType_In?: InputMaybe<Array<InputMaybe<NotificationEnum>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  resolvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  resolvedAt_Gt?: InputMaybe<Scalars['DateTime']['input']>;
  resolvedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  resolvedAt_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  resolvedAt_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  resolvedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  resolvedById?: InputMaybe<Scalars['ID']['input']>;
  resolvedById_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type ClientTypeTrackingSessionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  applicationId?: InputMaybe<Scalars['UUID']['input']>;
  applicationId_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  clientId_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  createdAt_Gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  domain_Icontains?: InputMaybe<Scalars['String']['input']>;
  employeeId?: InputMaybe<Scalars['UUID']['input']>;
  employeeId_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isAuthenticated?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  parentCategoryId?: InputMaybe<Scalars['UUID']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  updatedAt_Gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ClientTypeConnection = {
  __typename?: 'ClientTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ClientTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ClientType` and its cursor. */
export type ClientTypeEdge = {
  __typename?: 'ClientTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ClientType>;
};

export type CompleteMicrosoftOAuthMutation = {
  __typename?: 'CompleteMicrosoftOAuthMutation';
  connection?: Maybe<OAuthConnectionType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type CreateApiKeyMutation = {
  __typename?: 'CreateApiKeyMutation';
  apiKey?: Maybe<ApiKeyType>;
};

export type CreateClientApplicationMutation = {
  __typename?: 'CreateClientApplicationMutation';
  application?: Maybe<ClientApplicationType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type CreateClientApplicationMutationInput = {
  clientId: Scalars['UUID']['input'];
  resourceId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateClientEmployeeMutation = {
  __typename?: 'CreateClientEmployeeMutation';
  employee?: Maybe<ClientEmployeeType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type CreateClientEmployeeMutationInput = {
  clientId: Scalars['UUID']['input'];
  email: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateClientMutation = {
  __typename?: 'CreateClientMutation';
  client?: Maybe<ClientType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type CreateClientMutationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  domain: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateExtensionInstallationScriptInput = {
  clientId: Scalars['UUID']['input'];
};

export type CreateExtensionInstallationScriptMutation = {
  __typename?: 'CreateExtensionInstallationScriptMutation';
  configJson?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  script?: Maybe<Scalars['String']['output']>;
};

export type CreateExtensionUninstallationScriptInput = {
  clientId: Scalars['UUID']['input'];
};

export type CreateExtensionUninstallationScriptMutation = {
  __typename?: 'CreateExtensionUninstallationScriptMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  script?: Maybe<Scalars['String']['output']>;
};

export type CreateMicrosoftOAuthUrlMutation = {
  __typename?: 'CreateMicrosoftOAuthUrlMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  oauthUrl?: Maybe<MicrosoftOAuthUrlType>;
};

export type CreateNotificationChannelTopicMutation = {
  __typename?: 'CreateNotificationChannelTopicMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  notificationChannelTopic?: Maybe<NotificationChannelTopicType>;
};

export type CreateNotificationChannelTopicMutationInput = {
  applicationReviewStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  channelType: Scalars['String']['input'];
  clientIds: Array<InputMaybe<Scalars['String']['input']>>;
  emailAddresses: Array<InputMaybe<Scalars['String']['input']>>;
  isEnabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  notificationTypes: Array<InputMaybe<Scalars['String']['input']>>;
};

export type CreateOrganizationFromDiscoveryInput = {
  allowSameEmailSignups: Scalars['Boolean']['input'];
  intermediateToken: Scalars['String']['input'];
  memberName: Scalars['String']['input'];
  organizationDomain: Scalars['String']['input'];
  organizationName: Scalars['String']['input'];
};

export type CreateOrganizationFromDiscoveryMutation = {
  __typename?: 'CreateOrganizationFromDiscoveryMutation';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateUserMutation = {
  __typename?: 'CreateUserMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  user?: Maybe<UserType>;
};

export type CreateUserMutationInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type DeleteApiKeyMutation = {
  __typename?: 'DeleteApiKeyMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteClientApplicationMutation = {
  __typename?: 'DeleteClientApplicationMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteClientApplicationMutationInput = {
  clientId: Scalars['UUID']['input'];
  id: Scalars['UUID']['input'];
};

export type DeleteClientEmployeeMutation = {
  __typename?: 'DeleteClientEmployeeMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteClientEmployeeMutationInput = {
  clientId: Scalars['UUID']['input'];
  id: Scalars['UUID']['input'];
};

export type DeleteClientMutation = {
  __typename?: 'DeleteClientMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteNotificationChannelTopicMutation = {
  __typename?: 'DeleteNotificationChannelTopicMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteNotificationChannelTopicMutationInput = {
  id: Scalars['ID']['input'];
};

export type DeleteOrganizationMutation = {
  __typename?: 'DeleteOrganizationMutation';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteUserMutation = {
  __typename?: 'DeleteUserMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DestroySessionMutation = {
  __typename?: 'DestroySessionMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  success: Scalars['Boolean']['output'];
};

export type DisconnectMicrosoftOAuthMutation = {
  __typename?: 'DisconnectMicrosoftOAuthMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  /** Indicates whether the disconnection was successful. */
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DiscoveredOrganizationType = {
  __typename?: 'DiscoveredOrganizationType';
  organizationId?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
};

export type DissociateApiKeyFromClientMutation = {
  __typename?: 'DissociateApiKeyFromClientMutation';
  client?: Maybe<ClientType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type DissociateApiKeyFromClientMutationInput = {
  apiKeyId: Scalars['UUID']['input'];
  clientId: Scalars['UUID']['input'];
};

export type ErrorType = {
  __typename?: 'ErrorType';
  field?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export enum HistoricalActivityEventTypeEnum {
  ApplicationUse = 'APPLICATION_USE',
  CredentialUse = 'CREDENTIAL_USE',
  Notification = 'NOTIFICATION'
}

export type InviteUserMutation = {
  __typename?: 'InviteUserMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  user?: Maybe<UserType>;
};

export type InviteUserMutationInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type ListOrganizationsFromDiscoveryMutation = {
  __typename?: 'ListOrganizationsFromDiscoveryMutation';
  discoveredOrganizations?: Maybe<Array<Maybe<DiscoveredOrganizationType>>>;
};

/** Type representing Microsoft OAuth URL response */
export type MicrosoftOAuthUrlType = {
  __typename?: 'MicrosoftOAuthUrlType';
  /** The state parameter for OAuth flow */
  state: Scalars['String']['output'];
  /** The OAuth authorization URL */
  url: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptInvitation?: Maybe<AcceptInvitationMutation>;
  acknowledgeNotification?: Maybe<AcknowledgeNotificationMutation>;
  archiveNotification?: Maybe<ArchiveNotificationMutation>;
  associateApiKeyWithClient?: Maybe<AssociateApiKeyWithClientMutation>;
  authenticateImpersonationToken?: Maybe<AuthenticateImpersonationTokenMutation>;
  authenticateOrganization?: Maybe<AuthenticateOrganizationMutation>;
  completeMicrosoftOauth?: Maybe<CompleteMicrosoftOAuthMutation>;
  createApiKey?: Maybe<CreateApiKeyMutation>;
  createClient?: Maybe<CreateClientMutation>;
  createClientApplication?: Maybe<CreateClientApplicationMutation>;
  createClientEmployee?: Maybe<CreateClientEmployeeMutation>;
  createExtensionInstallationScript?: Maybe<CreateExtensionInstallationScriptMutation>;
  createExtensionUninstallationScript?: Maybe<CreateExtensionUninstallationScriptMutation>;
  createMicrosoftOauthUrl?: Maybe<CreateMicrosoftOAuthUrlMutation>;
  createNotificationChannelTopic?: Maybe<CreateNotificationChannelTopicMutation>;
  createOrganizationFromDiscovery?: Maybe<CreateOrganizationFromDiscoveryMutation>;
  createUser?: Maybe<CreateUserMutation>;
  deleteApiKey?: Maybe<DeleteApiKeyMutation>;
  deleteClient?: Maybe<DeleteClientMutation>;
  deleteClientApplication?: Maybe<DeleteClientApplicationMutation>;
  deleteClientEmployee?: Maybe<DeleteClientEmployeeMutation>;
  deleteNotificationChannelTopic?: Maybe<DeleteNotificationChannelTopicMutation>;
  deleteOrganization?: Maybe<DeleteOrganizationMutation>;
  deleteUser?: Maybe<DeleteUserMutation>;
  destroyUserSession?: Maybe<DestroySessionMutation>;
  disconnectMicrosoftOauth?: Maybe<DisconnectMicrosoftOAuthMutation>;
  dissociateApiKeyFromClient?: Maybe<DissociateApiKeyFromClientMutation>;
  inviteUser?: Maybe<InviteUserMutation>;
  listOrganizationsFromDiscovery?: Maybe<ListOrganizationsFromDiscoveryMutation>;
  recreateApplicationResourceGroup?: Maybe<RecreateApplicationResourceGroupMutation>;
  recreateResourceGroup?: Maybe<RecreateResourceGroupMutation>;
  refetchResourceFavicon?: Maybe<RefetchResourceFaviconMutation>;
  requestEmailDiscoveryToken?: Maybe<RequestEmailDiscoveryTokenMutation>;
  requestOauthDiscoveryUrl?: Maybe<RequestOAuthDiscoveryUrlMutation>;
  resolveNotification?: Maybe<ResolveNotificationMutation>;
  sendTestNotification?: Maybe<SendTestNotificationMutation>;
  /**
   * Mutation to set a resource as primary within its resource group.
   *
   * This mutation ensures that only one resource can be primary within a group
   * and handles the necessary state updates and propagation to tenant schemas.
   */
  setPrimaryResource?: Maybe<SetPrimaryResourceMutation>;
  /**
   * Mutation to update an ApplicationResource.
   * Currently supports updating is_visible field.
   */
  updateApplicationResource?: Maybe<UpdateApplicationResourceMutation>;
  updateApplicationResourceGroup?: Maybe<UpdateApplicationResourceGroupMutation>;
  updateClient?: Maybe<UpdateClientMutation>;
  updateClientApplication?: Maybe<UpdateClientApplicationMutation>;
  updateClientEmployee?: Maybe<UpdateClientEmployeeMutation>;
  updateNotificationChannelTopic?: Maybe<UpdateNotificationChannelTopicMutation>;
  updateResource?: Maybe<UpdateResourceMutation>;
  updateResourceGroup?: Maybe<UpdateResourceGroupMutation>;
  updateUser?: Maybe<UpdateUserMutation>;
  validateDiscoveryToken?: Maybe<ValidateDiscoveryTokenMutation>;
};


export type MutationAcceptInvitationArgs = {
  token: Scalars['String']['input'];
};


export type MutationAcknowledgeNotificationArgs = {
  input: AcknowledgeNotificationMutationInput;
};


export type MutationArchiveNotificationArgs = {
  input: ArchiveNotificationMutationInput;
};


export type MutationAssociateApiKeyWithClientArgs = {
  input: AssociateApiKeyWithClientMutationInput;
};


export type MutationAuthenticateImpersonationTokenArgs = {
  impersonationToken: Scalars['String']['input'];
};


export type MutationAuthenticateOrganizationArgs = {
  stytchOrganizationId: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationCompleteMicrosoftOauthArgs = {
  code: Scalars['String']['input'];
};


export type MutationCreateClientArgs = {
  input: CreateClientMutationInput;
};


export type MutationCreateClientApplicationArgs = {
  input: CreateClientApplicationMutationInput;
};


export type MutationCreateClientEmployeeArgs = {
  input: CreateClientEmployeeMutationInput;
};


export type MutationCreateExtensionInstallationScriptArgs = {
  input: CreateExtensionInstallationScriptInput;
};


export type MutationCreateExtensionUninstallationScriptArgs = {
  input: CreateExtensionUninstallationScriptInput;
};


export type MutationCreateNotificationChannelTopicArgs = {
  input: CreateNotificationChannelTopicMutationInput;
};


export type MutationCreateOrganizationFromDiscoveryArgs = {
  input: CreateOrganizationFromDiscoveryInput;
};


export type MutationCreateUserArgs = {
  input: CreateUserMutationInput;
};


export type MutationDeleteApiKeyArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteClientArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteClientApplicationArgs = {
  input: DeleteClientApplicationMutationInput;
};


export type MutationDeleteClientEmployeeArgs = {
  input: DeleteClientEmployeeMutationInput;
};


export type MutationDeleteNotificationChannelTopicArgs = {
  input: DeleteNotificationChannelTopicMutationInput;
};


export type MutationDeleteOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDisconnectMicrosoftOauthArgs = {
  id: Scalars['String']['input'];
};


export type MutationDissociateApiKeyFromClientArgs = {
  input: DissociateApiKeyFromClientMutationInput;
};


export type MutationInviteUserArgs = {
  input: InviteUserMutationInput;
};


export type MutationListOrganizationsFromDiscoveryArgs = {
  intermediateSessionToken: Scalars['String']['input'];
};


export type MutationRecreateApplicationResourceGroupArgs = {
  resourceId: Scalars['ID']['input'];
};


export type MutationRecreateResourceGroupArgs = {
  resourceId: Scalars['ID']['input'];
};


export type MutationRefetchResourceFaviconArgs = {
  resourceId: Scalars['ID']['input'];
};


export type MutationRequestEmailDiscoveryTokenArgs = {
  email: Scalars['String']['input'];
};


export type MutationRequestOauthDiscoveryUrlArgs = {
  provider: ProviderEnum;
};


export type MutationResolveNotificationArgs = {
  input: ResolveNotificationMutationInput;
};


export type MutationSendTestNotificationArgs = {
  input: SendTestNotificationMutationInput;
};


export type MutationSetPrimaryResourceArgs = {
  resourceId: Scalars['ID']['input'];
};


export type MutationUpdateApplicationResourceArgs = {
  id: Scalars['ID']['input'];
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateApplicationResourceGroupArgs = {
  resourceId: Scalars['ID']['input'];
  targetResourceId: Scalars['ID']['input'];
};


export type MutationUpdateClientArgs = {
  input: UpdateClientMutationInput;
};


export type MutationUpdateClientApplicationArgs = {
  input: UpdateClientApplicationMutationInput;
};


export type MutationUpdateClientEmployeeArgs = {
  input: UpdateClientEmployeeMutationInput;
};


export type MutationUpdateNotificationChannelTopicArgs = {
  input: UpdateNotificationChannelTopicMutationInput;
};


export type MutationUpdateResourceArgs = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  isForConsumers?: InputMaybe<Scalars['Boolean']['input']>;
  isPrimaryResource?: InputMaybe<Scalars['Boolean']['input']>;
  isSaas?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  mspVitalityScore?: InputMaybe<Scalars['Int']['input']>;
  productDescription?: InputMaybe<Scalars['String']['input']>;
  productDomainName?: InputMaybe<Scalars['String']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  resourceGroupId?: InputMaybe<Scalars['ID']['input']>;
  vendorDescription?: InputMaybe<Scalars['String']['input']>;
  vendorDomainName?: InputMaybe<Scalars['String']['input']>;
  vendorName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateResourceGroupArgs = {
  resourceId: Scalars['ID']['input'];
  targetResourceId: Scalars['ID']['input'];
};


export type MutationUpdateUserArgs = {
  input: UpdateUserMutationInput;
};


export type MutationValidateDiscoveryTokenArgs = {
  stytchTokenType: StytchTokenTypeEnum;
  token: Scalars['String']['input'];
};

/** An object with an ID */
export type Node = {
  /** The ID of the object */
  id: Scalars['ID']['output'];
};

export type NotificationAggregateGroupByFieldType = {
  __typename?: 'NotificationAggregateGroupByFieldType';
  notificationGroups?: Maybe<Array<Maybe<NotificationGroupType>>>;
};

export type NotificationAggregateType = {
  __typename?: 'NotificationAggregateType';
  groupBy?: Maybe<NotificationAggregateGroupByFieldType>;
};

export type NotificationChannelEmailRecipientType = Node & {
  __typename?: 'NotificationChannelEmailRecipientType';
  createdAt: Scalars['DateTime']['output'];
  emailAddress: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type NotificationChannelTopicClientType = Node & {
  __typename?: 'NotificationChannelTopicClientType';
  client?: Maybe<ClientType>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type NotificationChannelTopicEventType = Node & {
  __typename?: 'NotificationChannelTopicEventType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  notificationType?: Maybe<NotificationEnum>;
  updatedAt: Scalars['DateTime']['output'];
};

export type NotificationChannelTopicType = Node & {
  __typename?: 'NotificationChannelTopicType';
  applicationReviewStates: Array<Scalars['String']['output']>;
  clients?: Maybe<Array<Maybe<NotificationChannelTopicClientType>>>;
  createdAt: Scalars['DateTime']['output'];
  emailRecipients?: Maybe<Array<Maybe<NotificationChannelEmailRecipientType>>>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  notificationChannel?: Maybe<NotificationChannelType>;
  types?: Maybe<Array<Maybe<NotificationChannelTopicEventType>>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type NotificationChannelTopicTypeConnection = {
  __typename?: 'NotificationChannelTopicTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<NotificationChannelTopicTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `NotificationChannelTopicType` and its cursor. */
export type NotificationChannelTopicTypeEdge = {
  __typename?: 'NotificationChannelTopicTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<NotificationChannelTopicType>;
};

export type NotificationChannelType = Node & {
  __typename?: 'NotificationChannelType';
  channelType: TenantedNotificationChannelChannelTypeChoices;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** An enumeration. */
export enum NotificationEnum {
  FileUpload = 'FILE_UPLOAD',
  SaasDiscovered = 'SAAS_DISCOVERED',
  SharedLogin = 'SHARED_LOGIN'
}

export type NotificationGroupType = {
  __typename?: 'NotificationGroupType';
  count?: Maybe<Scalars['Int']['output']>;
  notificationType?: Maybe<NotificationEnum>;
};

export type NotificationType = Node & {
  __typename?: 'NotificationType';
  acknowledgedAt?: Maybe<Scalars['DateTime']['output']>;
  acknowledgedBy?: Maybe<UserType>;
  application?: Maybe<ClientApplicationType>;
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  archivedBy?: Maybe<UserType>;
  client?: Maybe<ClientType>;
  createdAt: Scalars['DateTime']['output'];
  employee?: Maybe<ClientEmployeeType>;
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  ignoreUntil?: Maybe<Scalars['DateTime']['output']>;
  notificationType?: Maybe<NotificationEnum>;
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  resolvedBy?: Maybe<UserType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type NotificationTypeConnection = {
  __typename?: 'NotificationTypeConnection';
  aggregate?: Maybe<NotificationAggregateType>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<NotificationTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `NotificationType` and its cursor. */
export type NotificationTypeEdge = {
  __typename?: 'NotificationTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<NotificationType>;
};

export type OAuthConnectionType = Node & {
  __typename?: 'OAuthConnectionType';
  connectionType?: Maybe<OAuthIntegrationTypeEnum>;
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** Whether the connection is active and not expired */
  isActive: Scalars['Boolean']['output'];
};

export type OAuthConnectionTypeConnection = {
  __typename?: 'OAuthConnectionTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OAuthConnectionTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `OAuthConnectionType` and its cursor. */
export type OAuthConnectionTypeEdge = {
  __typename?: 'OAuthConnectionTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<OAuthConnectionType>;
};

/** An enumeration. */
export enum OAuthIntegrationTypeEnum {
  MicrosoftPartnerCenter = 'MICROSOFT_PARTNER_CENTER'
}

export type OrganizationType = Node & {
  __typename?: 'OrganizationType';
  clientCount?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  employeeCount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organizationType: PublicOrganizationOrganizationTypeChoices;
  organizationTypeDisplay?: Maybe<Scalars['String']['output']>;
  stytchOrganizationId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userCount?: Maybe<Scalars['Int']['output']>;
};

export type OrganizationTypeConnection = {
  __typename?: 'OrganizationTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OrganizationTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `OrganizationType` and its cursor. */
export type OrganizationTypeEdge = {
  __typename?: 'OrganizationTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<OrganizationType>;
};

/** The Relay compliant `PageInfo` type, containing data necessary to paginate this connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export enum ProviderEnum {
  Google = 'GOOGLE',
  Microsoft = 'MICROSOFT'
}

/** An enumeration. */
export enum PublicOrganizationOrganizationTypeChoices {
  /** DISTRIBUTOR */
  Distributor = 'DISTRIBUTOR',
  /** MSP */
  Msp = 'MSP'
}

export type Query = {
  __typename?: 'Query';
  apiKey?: Maybe<ApiKeyType>;
  apiKeys?: Maybe<ApiKeyTypeConnection>;
  applicationResource?: Maybe<ApplicationResourceType>;
  applicationResources?: Maybe<ApplicationResourceTypeConnection>;
  client?: Maybe<ClientType>;
  clientApplication?: Maybe<ClientApplicationType>;
  clientApplicationActivities?: Maybe<ClientApplicationActivityTypeConnection>;
  clientApplicationUsages?: Maybe<Array<Maybe<ClientApplicationUsageType>>>;
  /** Query all client applications with comprehensive filtering */
  clientApplications?: Maybe<ClientApplicationTypeConnection>;
  clientEmployee?: Maybe<ClientEmployeeType>;
  /** Get applications that a client employee has interacted with */
  clientEmployeeApplicationInteractions?: Maybe<ClientEmployeeApplicationInteractionsResultType>;
  clientEmployeeFileUploads?: Maybe<ClientEmployeeFileUploadTypeConnection>;
  clientEmployeeSession?: Maybe<ClientEmployeeSessionType>;
  clientEmployeeSessions?: Maybe<ClientEmployeeSessionTypeConnection>;
  clientEmployees?: Maybe<ClientEmployeeTypeConnection>;
  clients?: Maybe<ClientTypeConnection>;
  currentUser?: Maybe<UserType>;
  employeeSession?: Maybe<ClientEmployeeSessionType>;
  employeeSessions?: Maybe<ClientEmployeeSessionTypeConnection>;
  notification?: Maybe<NotificationType>;
  notificationChannelTopic?: Maybe<NotificationChannelTopicType>;
  notificationChannelTopics?: Maybe<NotificationChannelTopicTypeConnection>;
  notifications?: Maybe<NotificationTypeConnection>;
  oauthConnections?: Maybe<OAuthConnectionTypeConnection>;
  organizations?: Maybe<OrganizationTypeConnection>;
  resource?: Maybe<ResourceType>;
  resourceCategories?: Maybe<ResourceCategoryTypeConnection>;
  resourceCategory?: Maybe<ResourceCategoryType>;
  resourceGroup?: Maybe<ResourceGroupType>;
  /** Get employees assigned to applications in the resource group */
  resourceGroupEmployees?: Maybe<ResourceGroupEmployeeTypeConnection>;
  /** Get all unresolved notifications for applications in the same resource group */
  resourceGroupNotifications?: Maybe<NotificationTypeConnection>;
  /** Get aggregated usage data for all applications in the same resource group */
  resourceGroupUsage?: Maybe<Array<Maybe<ResourceGroupUsageType>>>;
  resourceGroups?: Maybe<ResourceGroupTypeConnection>;
  resources?: Maybe<ResourceTypeConnection>;
  tenantedResourceGroups?: Maybe<TenantedResourceGroupTypeConnection>;
  user?: Maybe<UserType>;
  users?: Maybe<UserTypeConnection>;
};


export type QueryApiKeyArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
};


export type QueryApiKeysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryApplicationResourceArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryApplicationResourcesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isPrimaryResource?: InputMaybe<Scalars['Boolean']['input']>;
  isSaas?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  key_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  mspVitalityScore_Gt?: InputMaybe<Scalars['Int']['input']>;
  mspVitalityScore_Gte?: InputMaybe<Scalars['Int']['input']>;
  mspVitalityScore_Lt?: InputMaybe<Scalars['Int']['input']>;
  mspVitalityScore_Lte?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  parentCategoryId?: InputMaybe<Scalars['UUID']['input']>;
  productDescription?: InputMaybe<Scalars['String']['input']>;
  productDescription_Icontains?: InputMaybe<Scalars['String']['input']>;
  productDomainName?: InputMaybe<Scalars['String']['input']>;
  productDomainName_Icontains?: InputMaybe<Scalars['String']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  productName_Icontains?: InputMaybe<Scalars['String']['input']>;
  resourceGroup?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  vendorDescription?: InputMaybe<Scalars['String']['input']>;
  vendorDescription_Icontains?: InputMaybe<Scalars['String']['input']>;
  vendorDomainName?: InputMaybe<Scalars['String']['input']>;
  vendorDomainName_Icontains?: InputMaybe<Scalars['String']['input']>;
  vendorName?: InputMaybe<Scalars['String']['input']>;
  vendorName_Icontains?: InputMaybe<Scalars['String']['input']>;
};


export type QueryClientArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
};


export type QueryClientApplicationArgs = {
  clientId: Scalars['UUID']['input'];
  id: Scalars['UUID']['input'];
};


export type QueryClientApplicationActivitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  applicationId: Scalars['UUID']['input'];
  applicationId_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  date_Gt?: InputMaybe<Scalars['Date']['input']>;
  date_Gte?: InputMaybe<Scalars['Date']['input']>;
  date_Lt?: InputMaybe<Scalars['Date']['input']>;
  date_Lte?: InputMaybe<Scalars['Date']['input']>;
  employeeId?: InputMaybe<Scalars['ID']['input']>;
  employeeId_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  resourceId?: InputMaybe<Scalars['ID']['input']>;
  resourceId_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryClientApplicationUsagesArgs = {
  applicationId: Scalars['UUID']['input'];
  date_Gte: Scalars['Date']['input'];
  date_Lt: Scalars['Date']['input'];
  sortBy?: InputMaybe<Scalars['String']['input']>;
};


export type QueryClientApplicationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  businessOwner?: InputMaybe<Scalars['ID']['input']>;
  businessOwner_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  clientId_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Date?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Date_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Date_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  employees_Id?: InputMaybe<Scalars['UUID']['input']>;
  employees_Id_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasFileUploads?: InputMaybe<Scalars['Boolean']['input']>;
  hasFileUploadsByEmployee?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  managedBy?: InputMaybe<TenantedClientApplicationManagedByChoices>;
  managedBy_In?: InputMaybe<Array<InputMaybe<TenantedClientApplicationManagedByChoices>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  parentCategoryId?: InputMaybe<Scalars['UUID']['input']>;
  resource_CategoryId?: InputMaybe<Scalars['UUID']['input']>;
  resource_CategoryId_In?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  resource_IsPrimaryResource?: InputMaybe<Scalars['Boolean']['input']>;
  resource_ProductName?: InputMaybe<Scalars['String']['input']>;
  resource_ProductName_Icontains?: InputMaybe<Scalars['String']['input']>;
  resource_ProductName_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  reviewState?: InputMaybe<TenantedClientApplicationReviewStateChoices>;
  reviewState_In?: InputMaybe<Array<InputMaybe<TenantedClientApplicationReviewStateChoices>>>;
  sessionsEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  sessionsStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  supportedBy?: InputMaybe<TenantedClientApplicationSupportedByChoices>;
  supportedBy_In?: InputMaybe<Array<InputMaybe<TenantedClientApplicationSupportedByChoices>>>;
};


export type QueryClientEmployeeArgs = {
  clientId: Scalars['UUID']['input'];
  id: Scalars['UUID']['input'];
  sortBy?: InputMaybe<Scalars['String']['input']>;
};


export type QueryClientEmployeeApplicationInteractionsArgs = {
  applicationName?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  clientEmployeeId: Scalars['UUID']['input'];
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
};


export type QueryClientEmployeeFileUploadsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  applicationId?: InputMaybe<Scalars['UUID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  datetime?: InputMaybe<Scalars['DateTime']['input']>;
  datetime_Gt?: InputMaybe<Scalars['DateTime']['input']>;
  datetime_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  datetime_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  datetime_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  employeeId?: InputMaybe<Scalars['UUID']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  fileName_Icontains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  mimetype?: InputMaybe<Scalars['String']['input']>;
  mimetype_Icontains?: InputMaybe<Scalars['String']['input']>;
  mimetype_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  sessionId?: InputMaybe<Scalars['UUID']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  uploadSize?: InputMaybe<Scalars['Int']['input']>;
  uploadSize_Gt?: InputMaybe<Scalars['Int']['input']>;
  uploadSize_Gte?: InputMaybe<Scalars['Int']['input']>;
  uploadSize_Lt?: InputMaybe<Scalars['Int']['input']>;
  uploadSize_Lte?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryClientEmployeeSessionArgs = {
  clientId: Scalars['UUID']['input'];
  id: Scalars['UUID']['input'];
};


export type QueryClientEmployeeSessionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  applicationId?: InputMaybe<Scalars['UUID']['input']>;
  applicationId_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  clientId_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  createdAt_Gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  domain_Icontains?: InputMaybe<Scalars['String']['input']>;
  employeeId?: InputMaybe<Scalars['UUID']['input']>;
  employeeId_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isAuthenticated?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  parentCategoryId?: InputMaybe<Scalars['UUID']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  updatedAt_Gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryClientEmployeesArgs = {
  activityDateGte?: InputMaybe<Scalars['Date']['input']>;
  activityDateLte?: InputMaybe<Scalars['Date']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  applicationId?: InputMaybe<Scalars['UUID']['input']>;
  archivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  archivedAt_Gt?: InputMaybe<Scalars['DateTime']['input']>;
  archivedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  archivedAt_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  archivedAt_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  archivedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  archivedById?: InputMaybe<Scalars['ID']['input']>;
  archivedById_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  clientId_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_Icontains?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalId_Icontains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasFileUploads?: InputMaybe<Scalars['Boolean']['input']>;
  hasFileUploadsInApplication?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};


export type QueryClientsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  domain_Icontains?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_Icontains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEmployeeSessionArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryEmployeeSessionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  applicationId?: InputMaybe<Scalars['UUID']['input']>;
  applicationId_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  clientId_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  createdAt_Gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  domain_Icontains?: InputMaybe<Scalars['String']['input']>;
  employeeId?: InputMaybe<Scalars['UUID']['input']>;
  employeeId_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isAuthenticated?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  parentCategoryId?: InputMaybe<Scalars['UUID']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  updatedAt_Gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryNotificationArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryNotificationChannelTopicArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryNotificationChannelTopicsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNotificationsArgs = {
  acknowledgedAt?: InputMaybe<Scalars['DateTime']['input']>;
  acknowledgedAt_Gt?: InputMaybe<Scalars['DateTime']['input']>;
  acknowledgedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  acknowledgedAt_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  acknowledgedAt_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  acknowledgedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  acknowledgedById?: InputMaybe<Scalars['ID']['input']>;
  acknowledgedById_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  applicationId?: InputMaybe<Scalars['UUID']['input']>;
  applicationId_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  applicationProductName?: InputMaybe<Scalars['String']['input']>;
  application_Resource_ProductName?: InputMaybe<Scalars['String']['input']>;
  application_Resource_ProductName_Icontains?: InputMaybe<Scalars['String']['input']>;
  application_Resource_ProductName_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  archivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  archivedAt_Gt?: InputMaybe<Scalars['DateTime']['input']>;
  archivedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  archivedAt_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  archivedAt_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  archivedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  archivedById?: InputMaybe<Scalars['ID']['input']>;
  archivedById_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  clientId_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  employeeId?: InputMaybe<Scalars['UUID']['input']>;
  employeeId_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  executedAt?: InputMaybe<Scalars['DateTime']['input']>;
  executedAt_Gt?: InputMaybe<Scalars['DateTime']['input']>;
  executedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  executedAt_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  executedAt_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  executedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ignoredUntil?: InputMaybe<Scalars['DateTime']['input']>;
  ignoredUntil_Gt?: InputMaybe<Scalars['DateTime']['input']>;
  ignoredUntil_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  ignoredUntil_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  ignoredUntil_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  ignoredUntil_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  notificationType?: InputMaybe<NotificationEnum>;
  notificationType_In?: InputMaybe<Array<InputMaybe<NotificationEnum>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  resolvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  resolvedAt_Gt?: InputMaybe<Scalars['DateTime']['input']>;
  resolvedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  resolvedAt_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  resolvedAt_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  resolvedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  resolvedById?: InputMaybe<Scalars['ID']['input']>;
  resolvedById_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOauthConnectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  connectionType?: InputMaybe<OAuthIntegrationTypeEnum>;
  connectionType_In?: InputMaybe<Array<InputMaybe<OAuthIntegrationTypeEnum>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOrganizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  organizationType?: InputMaybe<PublicOrganizationOrganizationTypeChoices>;
  organizationType_In?: InputMaybe<Array<InputMaybe<PublicOrganizationOrganizationTypeChoices>>>;
  stytchOrganizationId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryResourceArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
};


export type QueryResourceCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  parent?: InputMaybe<Scalars['ID']['input']>;
  parent_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryResourceCategoryArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryResourceGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryResourceGroupEmployeesArgs = {
  activityDateGte?: InputMaybe<Scalars['Date']['input']>;
  activityDateLte?: InputMaybe<Scalars['Date']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  clientApplicationId: Scalars['ID']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  email_Icontains?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalId_Icontains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
};


export type QueryResourceGroupNotificationsArgs = {
  acknowledgedAt?: InputMaybe<Scalars['DateTime']['input']>;
  acknowledgedAt_Gt?: InputMaybe<Scalars['DateTime']['input']>;
  acknowledgedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  acknowledgedAt_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  acknowledgedAt_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  acknowledgedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  acknowledgedById?: InputMaybe<Scalars['ID']['input']>;
  acknowledgedById_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  applicationId?: InputMaybe<Scalars['UUID']['input']>;
  applicationId_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  applicationProductName?: InputMaybe<Scalars['String']['input']>;
  application_Resource_ProductName?: InputMaybe<Scalars['String']['input']>;
  application_Resource_ProductName_Icontains?: InputMaybe<Scalars['String']['input']>;
  application_Resource_ProductName_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  archivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  archivedAt_Gt?: InputMaybe<Scalars['DateTime']['input']>;
  archivedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  archivedAt_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  archivedAt_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  archivedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  archivedById?: InputMaybe<Scalars['ID']['input']>;
  archivedById_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  clientApplicationId: Scalars['UUID']['input'];
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  clientId_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  employeeId?: InputMaybe<Scalars['UUID']['input']>;
  employeeId_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  executedAt?: InputMaybe<Scalars['DateTime']['input']>;
  executedAt_Gt?: InputMaybe<Scalars['DateTime']['input']>;
  executedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  executedAt_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  executedAt_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  executedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ignoredUntil?: InputMaybe<Scalars['DateTime']['input']>;
  ignoredUntil_Gt?: InputMaybe<Scalars['DateTime']['input']>;
  ignoredUntil_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  ignoredUntil_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  ignoredUntil_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  ignoredUntil_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  includeResolved?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  notificationType?: InputMaybe<NotificationEnum>;
  notificationType_In?: InputMaybe<Array<InputMaybe<NotificationEnum>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  resolvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  resolvedAt_Gt?: InputMaybe<Scalars['DateTime']['input']>;
  resolvedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  resolvedAt_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  resolvedAt_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  resolvedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  resolvedById?: InputMaybe<Scalars['ID']['input']>;
  resolvedById_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};


export type QueryResourceGroupUsageArgs = {
  applicationId?: InputMaybe<Scalars['UUID']['input']>;
  applicationIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  clientApplicationId: Scalars['UUID']['input'];
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  employeeId?: InputMaybe<Scalars['UUID']['input']>;
  employeeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  includeBreakdown?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryResourceGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
};


export type QueryResourcesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isForConsumers?: InputMaybe<Scalars['Boolean']['input']>;
  isPrimaryResource?: InputMaybe<Scalars['Boolean']['input']>;
  isSaas?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  key_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  mspVitalityScore_Gt?: InputMaybe<Scalars['Int']['input']>;
  mspVitalityScore_Gte?: InputMaybe<Scalars['Int']['input']>;
  mspVitalityScore_Lt?: InputMaybe<Scalars['Int']['input']>;
  mspVitalityScore_Lte?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  parentCategoryId?: InputMaybe<Scalars['UUID']['input']>;
  productDescription?: InputMaybe<Scalars['String']['input']>;
  productDescription_Icontains?: InputMaybe<Scalars['String']['input']>;
  productDomainName?: InputMaybe<Scalars['String']['input']>;
  productDomainName_Icontains?: InputMaybe<Scalars['String']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  productName_Icontains?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  vendorDescription?: InputMaybe<Scalars['String']['input']>;
  vendorDescription_Icontains?: InputMaybe<Scalars['String']['input']>;
  vendorDomainName?: InputMaybe<Scalars['String']['input']>;
  vendorDomainName_Icontains?: InputMaybe<Scalars['String']['input']>;
  vendorName?: InputMaybe<Scalars['String']['input']>;
  vendorName_Icontains?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTenantedResourceGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isMspModified?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  publicResourceGroupId?: InputMaybe<Scalars['UUID']['input']>;
  publicResourceGroupId_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryUserArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_Icontains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};

export type RecreateApplicationResourceGroupMutation = {
  __typename?: 'RecreateApplicationResourceGroupMutation';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  resource?: Maybe<ApplicationResourceType>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RecreateResourceGroupMutation = {
  __typename?: 'RecreateResourceGroupMutation';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  resource?: Maybe<ResourceType>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RefetchResourceFaviconMutation = {
  __typename?: 'RefetchResourceFaviconMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  resource?: Maybe<ResourceType>;
};

export type RequestEmailDiscoveryTokenMutation = {
  __typename?: 'RequestEmailDiscoveryTokenMutation';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RequestOAuthDiscoveryUrlMutation = {
  __typename?: 'RequestOAuthDiscoveryUrlMutation';
  url?: Maybe<Scalars['String']['output']>;
};

export type ResolveNotificationMutation = {
  __typename?: 'ResolveNotificationMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  notification?: Maybe<NotificationType>;
};

export type ResolveNotificationMutationInput = {
  id: Scalars['String']['input'];
};

export type ResourceCategoryType = Node & {
  __typename?: 'ResourceCategoryType';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  parent?: Maybe<ResourceCategoryType>;
  resource?: Maybe<ResourceTypeConnection>;
};


export type ResourceCategoryTypeResourceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isForConsumers?: InputMaybe<Scalars['Boolean']['input']>;
  isPrimaryResource?: InputMaybe<Scalars['Boolean']['input']>;
  isSaas?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  key_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  mspVitalityScore_Gt?: InputMaybe<Scalars['Int']['input']>;
  mspVitalityScore_Gte?: InputMaybe<Scalars['Int']['input']>;
  mspVitalityScore_Lt?: InputMaybe<Scalars['Int']['input']>;
  mspVitalityScore_Lte?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  parentCategoryId?: InputMaybe<Scalars['UUID']['input']>;
  productDescription?: InputMaybe<Scalars['String']['input']>;
  productDescription_Icontains?: InputMaybe<Scalars['String']['input']>;
  productDomainName?: InputMaybe<Scalars['String']['input']>;
  productDomainName_Icontains?: InputMaybe<Scalars['String']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  productName_Icontains?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  vendorDescription?: InputMaybe<Scalars['String']['input']>;
  vendorDescription_Icontains?: InputMaybe<Scalars['String']['input']>;
  vendorDomainName?: InputMaybe<Scalars['String']['input']>;
  vendorDomainName_Icontains?: InputMaybe<Scalars['String']['input']>;
  vendorName?: InputMaybe<Scalars['String']['input']>;
  vendorName_Icontains?: InputMaybe<Scalars['String']['input']>;
};

export type ResourceCategoryTypeConnection = {
  __typename?: 'ResourceCategoryTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ResourceCategoryTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ResourceCategoryType` and its cursor. */
export type ResourceCategoryTypeEdge = {
  __typename?: 'ResourceCategoryTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ResourceCategoryType>;
};

/**
 * Type that holds all applications in the same resource group along with aggregated stats.
 * This provides efficient batch loading of resource group data.
 */
export type ResourceGroupApplicationsType = {
  __typename?: 'ResourceGroupApplicationsType';
  /** All client applications in the same resource group */
  applications: Array<Maybe<ClientApplicationType>>;
  /** The primary application in the resource group */
  primaryApplication?: Maybe<ClientApplicationType>;
  /** Aggregated statistics across all applications in the resource group */
  stats: ResourceGroupStatsType;
};

/**
 * Represents an employee with aggregated activity data across all applications
 * in a resource group. This type includes metadata about their interactions
 * with applications in the group.
 */
export type ResourceGroupEmployeeType = Node & {
  __typename?: 'ResourceGroupEmployeeType';
  /** Applications in the resource group that this employee has interacted with */
  applications?: Maybe<Array<Maybe<ClientApplicationType>>>;
  client: ClientType;
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ResourceGroupEmployeeTypeConnection = {
  __typename?: 'ResourceGroupEmployeeTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ResourceGroupEmployeeTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ResourceGroupEmployeeType` and its cursor. */
export type ResourceGroupEmployeeTypeEdge = {
  __typename?: 'ResourceGroupEmployeeTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ResourceGroupEmployeeType>;
};

export type ResourceGroupStatsType = {
  __typename?: 'ResourceGroupStatsType';
  /** Number of applications in the resource group for this client */
  applicationCount: Scalars['Int']['output'];
  /** DateTime of the last known session activity across all applications in the resource group */
  lastSessionTime?: Maybe<Scalars['DateTime']['output']>;
  /** Total unique employees across all applications in the resource group */
  totalEmployees: Scalars['Int']['output'];
  /** Total unique employees who have authenticated (logged in) to any application in the resource group */
  totalEmployeesAuthenticated: Scalars['Int']['output'];
  /** Total notifications across all applications in the resource group */
  totalNotifications: Scalars['Int']['output'];
  /** Total sessions across all applications in the resource group */
  totalSessions: Scalars['Int']['output'];
};

export type ResourceGroupType = Node & {
  __typename?: 'ResourceGroupType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  primaryResource?: Maybe<ResourceType>;
  resources: ResourceTypeConnection;
  updatedAt: Scalars['DateTime']['output'];
};


export type ResourceGroupTypeResourcesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ResourceGroupTypeConnection = {
  __typename?: 'ResourceGroupTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ResourceGroupTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ResourceGroupType` and its cursor. */
export type ResourceGroupTypeEdge = {
  __typename?: 'ResourceGroupTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ResourceGroupType>;
};

/**
 * Represents aggregated usage data for a resource group on a specific date.
 * This type aggregates ClientApplicationActivity data across all applications
 * in the same resource group.
 */
export type ResourceGroupUsageType = {
  __typename?: 'ResourceGroupUsageType';
  /** Breakdown of usage by application (optional for detailed view) */
  applicationBreakdown?: Maybe<Array<Maybe<ApplicationUsageBreakdownType>>>;
  /** Number of distinct applications with activity on this date */
  applicationCount: Scalars['Int']['output'];
  /** Date of the usage activity */
  date: Scalars['Date']['output'];
  /** Number of distinct employees with activity on this date */
  employeeCount: Scalars['Int']['output'];
  /** UUID of the resource group (null if no resource group exists) */
  resourceGroupId?: Maybe<Scalars['UUID']['output']>;
  /** Total event count across all applications in the resource group for this date */
  totalEventCount: Scalars['Int']['output'];
};

export type ResourceType = Node & {
  __typename?: 'ResourceType';
  category?: Maybe<ResourceCategoryType>;
  createdAt: Scalars['DateTime']['output'];
  enrichedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isForConsumers: Scalars['Boolean']['output'];
  isPrimaryResource: Scalars['Boolean']['output'];
  isSaas: Scalars['Boolean']['output'];
  isVisible: Scalars['Boolean']['output'];
  key?: Maybe<Scalars['String']['output']>;
  mspVitalityScore: Scalars['Int']['output'];
  nonPrimaryResourcesCount?: Maybe<Scalars['Int']['output']>;
  productDescription?: Maybe<Scalars['String']['output']>;
  productDomainName?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  resourceGroup?: Maybe<ResourceGroupType>;
  signedLogoUrl?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  vendorDescription?: Maybe<Scalars['String']['output']>;
  vendorDomainName?: Maybe<Scalars['String']['output']>;
  vendorName?: Maybe<Scalars['String']['output']>;
};

export type ResourceTypeConnection = {
  __typename?: 'ResourceTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ResourceTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ResourceType` and its cursor. */
export type ResourceTypeEdge = {
  __typename?: 'ResourceTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ResourceType>;
};

export type SendTestNotificationMutation = {
  __typename?: 'SendTestNotificationMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SendTestNotificationMutationInput = {
  emailAddresses: Array<InputMaybe<Scalars['String']['input']>>;
  ruleName: Scalars['String']['input'];
};

export type SessionsPerDateType = {
  __typename?: 'SessionsPerDateType';
  count?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
};

/**
 * Mutation to set a resource as primary within its resource group.
 *
 * This mutation ensures that only one resource can be primary within a group
 * and handles the necessary state updates and propagation to tenant schemas.
 */
export type SetPrimaryResourceMutation = {
  __typename?: 'SetPrimaryResourceMutation';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  resource?: Maybe<ResourceType>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum StytchTokenTypeEnum {
  Discovery = 'DISCOVERY',
  DiscoveryOauth = 'DISCOVERY_OAUTH',
  MultiTenantImpersonation = 'MULTI_TENANT_IMPERSONATION'
}

/** An enumeration. */
export enum TenantedClientApplicationManagedByChoices {
  /** Client */
  Client = 'CLIENT',
  /** MSP */
  Msp = 'MSP',
  /** Vendor */
  Vendor = 'VENDOR'
}

/** An enumeration. */
export enum TenantedClientApplicationReviewStateChoices {
  /** Approved */
  Approved = 'APPROVED',
  /** Discovered */
  Discovered = 'DISCOVERED',
  /** Evaluating */
  Evaluating = 'EVALUATING',
  /** Unapproved */
  Unapproved = 'UNAPPROVED'
}

/** An enumeration. */
export enum TenantedClientApplicationSupportedByChoices {
  /** Client */
  Client = 'CLIENT',
  /** MSP */
  Msp = 'MSP',
  /** Vendor */
  Vendor = 'VENDOR'
}

/** An enumeration. */
export enum TenantedClientEmployeeSessionLoginMethodChoices {
  /** Guest */
  Guest = 'GUEST',
  /** Manual */
  Manual = 'MANUAL',
  /** Single Sign-On */
  Sso = 'SSO',
  /** Unknown */
  Unknown = 'UNKNOWN'
}

/** An enumeration. */
export enum TenantedNotificationChannelChannelTypeChoices {
  /** AUTOTASK */
  Autotask = 'AUTOTASK',
  /** EMAIL */
  Email = 'EMAIL',
  /** SLACK */
  Slack = 'SLACK'
}

export type TenantedResourceGroupType = Node & {
  __typename?: 'TenantedResourceGroupType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isMspModified: Scalars['Boolean']['output'];
  primaryResource?: Maybe<ApplicationResourceType>;
  resources?: Maybe<ApplicationResourceTypeConnection>;
  updatedAt: Scalars['DateTime']['output'];
};


export type TenantedResourceGroupTypeResourcesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isPrimaryResource?: InputMaybe<Scalars['Boolean']['input']>;
  isSaas?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  key_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  mspVitalityScore_Gt?: InputMaybe<Scalars['Int']['input']>;
  mspVitalityScore_Gte?: InputMaybe<Scalars['Int']['input']>;
  mspVitalityScore_Lt?: InputMaybe<Scalars['Int']['input']>;
  mspVitalityScore_Lte?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  parentCategoryId?: InputMaybe<Scalars['UUID']['input']>;
  productDescription?: InputMaybe<Scalars['String']['input']>;
  productDescription_Icontains?: InputMaybe<Scalars['String']['input']>;
  productDomainName?: InputMaybe<Scalars['String']['input']>;
  productDomainName_Icontains?: InputMaybe<Scalars['String']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  productName_Icontains?: InputMaybe<Scalars['String']['input']>;
  resourceGroup?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  vendorDescription?: InputMaybe<Scalars['String']['input']>;
  vendorDescription_Icontains?: InputMaybe<Scalars['String']['input']>;
  vendorDomainName?: InputMaybe<Scalars['String']['input']>;
  vendorDomainName_Icontains?: InputMaybe<Scalars['String']['input']>;
  vendorName?: InputMaybe<Scalars['String']['input']>;
  vendorName_Icontains?: InputMaybe<Scalars['String']['input']>;
};

export type TenantedResourceGroupTypeConnection = {
  __typename?: 'TenantedResourceGroupTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TenantedResourceGroupTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `TenantedResourceGroupType` and its cursor. */
export type TenantedResourceGroupTypeEdge = {
  __typename?: 'TenantedResourceGroupTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<TenantedResourceGroupType>;
};

export type UpdateApplicationResourceGroupMutation = {
  __typename?: 'UpdateApplicationResourceGroupMutation';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  resource?: Maybe<ApplicationResourceType>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Mutation to update an ApplicationResource.
 * Currently supports updating is_visible field.
 */
export type UpdateApplicationResourceMutation = {
  __typename?: 'UpdateApplicationResourceMutation';
  applicationResource?: Maybe<ApplicationResourceType>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateClientApplicationMutation = {
  __typename?: 'UpdateClientApplicationMutation';
  application?: Maybe<ClientApplicationType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type UpdateClientApplicationMutationInput = {
  businessOwnerId?: InputMaybe<Scalars['UUID']['input']>;
  clientId: Scalars['UUID']['input'];
  id: Scalars['UUID']['input'];
  managedBy?: InputMaybe<TenantedClientApplicationManagedByChoices>;
  notes?: InputMaybe<Scalars['String']['input']>;
  reviewState?: InputMaybe<TenantedClientApplicationReviewStateChoices>;
  supportedBy?: InputMaybe<TenantedClientApplicationSupportedByChoices>;
};

export type UpdateClientEmployeeMutation = {
  __typename?: 'UpdateClientEmployeeMutation';
  employee?: Maybe<ClientEmployeeType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type UpdateClientEmployeeMutationInput = {
  clientId: Scalars['UUID']['input'];
  email: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
};

export type UpdateClientMutation = {
  __typename?: 'UpdateClientMutation';
  client?: Maybe<ClientType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type UpdateClientMutationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateNotificationChannelTopicMutation = {
  __typename?: 'UpdateNotificationChannelTopicMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  notificationChannelTopic?: Maybe<NotificationChannelTopicType>;
};

export type UpdateNotificationChannelTopicMutationInput = {
  applicationReviewStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  channelType?: InputMaybe<Scalars['String']['input']>;
  clientIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  emailAddresses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id: Scalars['ID']['input'];
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notificationTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateResourceGroupMutation = {
  __typename?: 'UpdateResourceGroupMutation';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  resource?: Maybe<ResourceType>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateResourceMutation = {
  __typename?: 'UpdateResourceMutation';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  resource?: Maybe<ResourceType>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateUserMutation = {
  __typename?: 'UpdateUserMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  user?: Maybe<UserType>;
};

export type UpdateUserMutationInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
};

export type UserType = Node & {
  __typename?: 'UserType';
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  roles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  stytchMemberId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type UserTypeConnection = {
  __typename?: 'UserTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<UserTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `UserType` and its cursor. */
export type UserTypeEdge = {
  __typename?: 'UserTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<UserType>;
};

export type ValidateDiscoveryTokenMutation = {
  __typename?: 'ValidateDiscoveryTokenMutation';
  discoveredOrganizations?: Maybe<Array<Maybe<DiscoveredOrganizationType>>>;
  intermediateSessionToken?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};
